var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    {
      attrs: { "popper-class": "option-menu", width: "auto" },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "option-wrap",
          on: {
            click: function ($event) {
              _vm.visible = false
            },
          },
        },
        [_vm._t("default")],
        2
      ),
      _c(
        "div",
        {
          staticClass: "link-text option-menu-icon-title",
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [
          _vm.icon
            ? _c("i", {
                staticClass: "icon",
                class: _vm.icon,
                style: _vm.iconStyle,
              })
            : _vm._e(),
          _vm.title
            ? _c("span", { domProps: { textContent: _vm._s(_vm.title) } })
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }